import React, {useEffect, useState} from "react";
import {Link} from 'react-router-dom';
const Shapka = () => {
    const [mlShapka, setMlShapka] = useState(19);

    function shuffleArray(array: number[]) {
        for (let i = array.length - 1; i > 0; i--) {
            // Генерируем случайный индекс от 0 до i
            const j = Math.floor(Math.random() * (i + 1));

            // Меняем местами элементы array[i] и array[j]
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    }

    const myArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47];
    const shuffledArray = shuffleArray(myArray.slice()); // Используем slice() для создания копии массива

    const stylesShapka = { marginLeft: `${mlShapka}px` };

    const fetchData = () => {
        const banner = document.querySelector('.navbar-head');
        const clientWidth = banner ? banner?.clientWidth - 120 : null;
        const widthPic = 60;
        const marginPic = 19;
        if(clientWidth) {
            let countPic = Math.floor(clientWidth / (widthPic + marginPic));
            // mlShapka = (clientWidth - countPic * widthPic) / (countPic + 1);
            setMlShapka(Math.floor((clientWidth - countPic * widthPic) / (countPic + 1)));

            let visiblePics = document.querySelectorAll('.banner-center div.shapka');
            let i = countPic;
            // Перебираем выбранные элементы и добавляем класс
            visiblePics.forEach(child =>  {
                if(i > 0) {
                    child.classList.add('visible'); // Добавляем класс 'active'
                } else {
                    child.classList.remove('visible'); // Добавляем класс 'active'
                }
                i--;
            });
            // console.log(clientWidth, mlShapka, visiblePics, countPic, Array.from(visiblePics));
        }

        // Здесь вы можете выполнять запросы к API или другие действия
    };

    // Используем useEffect для вызова функции при загрузке компонента
    useEffect(() =>  {
        fetchData();
        const resizeHandler = () => fetchData();
        window.addEventListener('resize', resizeHandler);
        return () => window.removeEventListener('resize', resizeHandler);
    }, []); // Пустой массив зависимостей означает, что эффект выполнится только один раз при монтировании

    return (
        <div className="navbar-head">
            <Link to="/">
                <div className="banner-left">
                    <img src={'/image/shapka/' + shuffledArray[0] + '.jpg'} width="60" height="60" alt=""/>
                    <img src={'/image/shapka/' + shuffledArray[1] + '.jpg'} width="60" height="60" alt=""/>
                </div>
                <div className="banner-center">
                    <div className="shapka" style={stylesShapka}>
                        <img src={'/image/shapka/' + shuffledArray[2] + '.jpg'} width="60" height="60" alt=""/>
                        <img src={'/image/shapka/' + shuffledArray[3] + '.jpg'} width="60" height="60" alt=""/>
                    </div>
                    <div className="shapka" style={stylesShapka}>
                        <img src={'/image/shapka/' + shuffledArray[4] + '.jpg'} width="60" height="60" alt=""/>
                        <img src={'/image/shapka/' + shuffledArray[5] + '.jpg'} width="60" height="60" alt=""/>
                    </div>
                    <div className="shapka" style={stylesShapka}>
                        <img src={'/image/shapka/' + shuffledArray[6] + '.jpg'} width="60" height="60" alt=""/>
                        <img src={'/image/shapka/' + shuffledArray[7] + '.jpg'} width="60" height="60" alt=""/>
                    </div>
                    <div className="shapka" style={stylesShapka}>
                        <img src={'/image/shapka/' + shuffledArray[8] + '.jpg'} width="60" height="60" alt=""/>
                        <img src={'/image/shapka/' + shuffledArray[9] + '.jpg'} width="60" height="60" alt=""/>
                    </div>
                    <div className="shapka" style={stylesShapka}>
                        <img src={'/image/shapka/' + shuffledArray[10] + '.jpg'} width="60" height="60" alt=""/>
                        <img src={'/image/shapka/' + shuffledArray[11] + '.jpg'} width="60" height="60" alt=""/>
                    </div>
                    <div className="shapka" style={stylesShapka}>
                        <img src={'/image/shapka/' + shuffledArray[12] + '.jpg'} width="60" height="60" alt=""/>
                        <img src={'/image/shapka/' + shuffledArray[13] + '.jpg'} width="60" height="60" alt=""/>
                    </div>
                    <div className="shapka" style={stylesShapka}>
                        <img src={'/image/shapka/' + shuffledArray[14] + '.jpg'} width="60" height="60" alt=""/>
                        <img src={'/image/shapka/' + shuffledArray[15] + '.jpg'} width="60" height="60" alt=""/>
                    </div>
                    <div className="shapka" style={stylesShapka}>
                        <img src={'/image/shapka/' + shuffledArray[16] + '.jpg'} width="60" height="60" alt=""/>
                        <img src={'/image/shapka/' + shuffledArray[17] + '.jpg'} width="60" height="60" alt=""/>
                    </div>
                    <div className="shapka" style={stylesShapka}>
                        <img src={'/image/shapka/' + shuffledArray[18] + '.jpg'} width="60" height="60" alt=""/>
                        <img src={'/image/shapka/' + shuffledArray[19] + '.jpg'} width="60" height="60" alt=""/>
                    </div>
                    <div className="shapka" style={stylesShapka}>
                        <img src={'/image/shapka/' + shuffledArray[20] + '.jpg'} width="60" height="60" alt=""/>
                        <img src={'/image/shapka/' + shuffledArray[21] + '.jpg'} width="60" height="60" alt=""/>
                    </div>
                    <div className="shapka" style={stylesShapka}>
                        <img src={'/image/shapka/' + shuffledArray[22] + '.jpg'} width="60" height="60" alt=""/>
                        <img src={'/image/shapka/' + shuffledArray[23] + '.jpg'} width="60" height="60" alt=""/>
                    </div>
                    <div className="shapka" style={stylesShapka}>
                        <img src={'/image/shapka/' + shuffledArray[24] + '.jpg'} width="60" height="60" alt=""/>
                        <img src={'/image/shapka/' + shuffledArray[25] + '.jpg'} width="60" height="60" alt=""/>
                    </div>
                    <div className="shapka" style={stylesShapka}>
                        <img src={'/image/shapka/' + shuffledArray[26] + '.jpg'} width="60" height="60" alt=""/>
                        <img src={'/image/shapka/' + shuffledArray[27] + '.jpg'} width="60" height="60" alt=""/>
                    </div>
                    <div className="shapka" style={stylesShapka}>
                        <img src={'/image/shapka/' + shuffledArray[28] + '.jpg'} width="60" height="60" alt=""/>
                        <img src={'/image/shapka/' + shuffledArray[29] + '.jpg'} width="60" height="60" alt=""/>
                    </div>
                    <div className="shapka" style={stylesShapka}>
                        <img src={'/image/shapka/' + shuffledArray[30] + '.jpg'} width="60" height="60" alt=""/>
                        <img src={'/image/shapka/' + shuffledArray[31] + '.jpg'} width="60" height="60" alt=""/>
                    </div>
                    <div className="shapka" style={stylesShapka}>
                        <img src={'/image/shapka/' + shuffledArray[32] + '.jpg'} width="60" height="60" alt=""/>
                        <img src={'/image/shapka/' + shuffledArray[33] + '.jpg'} width="60" height="60" alt=""/>
                    </div>
                    <div className="shapka" style={stylesShapka}>
                        <img src={'/image/shapka/' + shuffledArray[34] + '.jpg'} width="60" height="60" alt=""/>
                        <img src={'/image/shapka/' + shuffledArray[35] + '.jpg'} width="60" height="60" alt=""/>
                    </div>
                    <div className="shapka" style={stylesShapka}>
                        <img src={'/image/shapka/' + shuffledArray[36] + '.jpg'} width="60" height="60" alt=""/>
                        <img src={'/image/shapka/' + shuffledArray[37] + '.jpg'} width="60" height="60" alt=""/>
                    </div>
                </div>
                <div className="banner-right">
                    <img src={'/image/shapka/' + shuffledArray[38] + '.jpg'} width="60" height="60" alt=""/>
                    <img src={'/image/shapka/' + shuffledArray[39] + '.jpg'} width="60" height="60" alt=""/>
                </div>
            </Link>
        </div>
    );

}

export default Shapka;